import axios from 'axios';
import { Product } from '@pointOfSale/models';
import { getNextPageProducts } from './processes';
import * as api from './api';
import * as MutationTypes from './mutationsTypes';
import { ProductMaster } from './models';

export const productMasterListRequest = async ({ commit }) => {
  const response = await api.productMasterListRequest();
  const productMasterList = ProductMaster.toInstanceList(response.data.results);
  commit(MutationTypes.PRODUCT_MASTER_LIST, productMasterList);
};

export const createProductMasterRequest = async ({ commit }, productMaster) => {
  const formDataProductMaster = productMaster.getFormData();
  const response = await api.createProductMasterRequest(formDataProductMaster);
  const newProductMaster = ProductMaster.toInstance(response.data);
  commit(MutationTypes.CREATE_PRODUCT_MASTER_SUCCESS, newProductMaster);
};

export const updateProductMasterRequest = async ({ commit }, productMaster) => {
  const productMasterGuid = productMaster.guid;
  const formDataProductMaster = productMaster.getFormData();
  const updatedProductMaster = await api.updateProductMasterRequest(productMasterGuid, formDataProductMaster);
  commit(MutationTypes.UPDATE_PRODUCT_MASTER_SUCCESS, updatedProductMaster);
};

export const deleteProductMasterRequest = async ({ commit }, productMaster) => {
  const serializeProductMaster = productMaster.serialize();
  const productMasterGuid = serializeProductMaster.guid;
  const deleteProductMaster = await api.deleteProductMasterRequest(productMasterGuid);
  commit(MutationTypes.DELETE_PRODUCT_MASTER_SUCCESS, deleteProductMaster);
};

export const propagateProductMasterRequest = async ({ commit }, productMaster) => {
  const serializeProductMaster = productMaster.serialize();
  const productMasterGuid = serializeProductMaster.guid;
  const propagateProductMaster = await api.propagateProductMasterRequest(productMasterGuid);
  commit(MutationTypes.PROPAGATE_PRODUCT_MASTER_SUCCESS, propagateProductMaster);
};

export const masterProductListSearchRequest = async ({
  commit,
// eslint-disable-next-line camelcase
}, { search, product_master }) => {
  try {
    if (!(search === '' || search === null)) {
      // https://stackoverflow.com/questions/30233302/promise-is-it-possible-to-force-cancel-a-promise
      const { CancelToken } = axios;
      const source = CancelToken.source();
      const { token } = source;
      commit(MutationTypes.PRODUCT_SEARCH_LIST_CANCEL_TOKEN, source);
      const response = await api.productListSearchRequest(token, { search, product_master });
      if (response) {
        const { count, results } = response.data;
        const productList = Product.toInstanceList(results);
        commit(MutationTypes.PRODUCT_SEARCH_LIST_UPDATE, { productList, count });
        if (response.data.next) {
          await getNextPageProducts(commit, response.data.next, token);
        }
      }
      commit(MutationTypes.PRODUCT_SEARCH_LIST_SUCCESS, true);
    } else {
      commit(MutationTypes.PRODUCT_SEARCH_CLEAR_LIST);
    }
  } catch (err) {
    commit(MutationTypes.PRODUCT_SEARCH_LIST_SUCCESS, false);
    throw err;
  }
};
